import React, { Component } from 'react'
import SideMenu from '../SideMenu/SideMenu'
import { actions, caseFilterErrorMessages } from '../../helpers/messages';
import CaseSearchComponent from './CaseSearch';
import RecursiveList from './RecursiveList';
import ErrorMsgBlockComponent from '../Error/ErrorMessageBlock';
import LogUploadContainer from './Upload';
import CustomModal from '../../shared/CustomModal';

export default class CaseListComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showUploadModal: false,
			uploadProgress: 0
		}
	}

	toggleUploadModal = () => {
		this.setState(prevState => {
			return {
				showUploadModal: !prevState.showUploadModal
			}
		})
	}

	render() {
		const { loading, caseList, handleSearchSubmit, handleReset, userList, getUserList, searchError, searched, searchParams, handleDownload,
			isFilePreparing, downloadError, downloadSuccess } = this.props;
		const { showUploadModal, uploadProgress } = this.state;

		return (
			<>
				{loading ? <div className="loading-overlay"><span>{actions.load}</span></div> : null}
				<div className="bgGray">
					<div className="container-fluid">
						<div className="row">
							<div className="col-md-1">
								<SideMenu uploadProgress={uploadProgress} />
							</div>
							<div className="col-md-11">
								<div className="surgeon-list data-list-tabs table-wrap px-3" data-testid="deviceList">
									<div className="row">
										<div className="col-md-12">
											<h1 className="file-list-heading">System Logs</h1>
										</div>
									</div>
									{/* Filter Block */}
									<div className="row">
										<div className="col-md-12">
											<CaseSearchComponent userList={userList} handleSearchSubmit={handleSearchSubmit} handleReset={handleReset} getUserList={getUserList} uploadOnClick={this.toggleUploadModal} />
										</div>
									</div>

									{/* List Block */}
									<div className="device-list-container mt-3">
										{loading ? '' :
											caseList?.length ?
												<RecursiveList
													caseList={caseList}
													loading={loading}
													showPagination={true}
													searched={searched}
													searchParams={searchParams}
													handleDownload={handleDownload}
													isFilePreparing={isFilePreparing}
													downloadSuccess={downloadSuccess}
													downloadError={downloadError}
													uploadOnClick={this.toggleUploadModal}
												/>
												: searched ? (searchError ? <>
													{/* Error after search */}
													<div className="row">
														<div className="col-sm-12">
															<ErrorMsgBlockComponent errorObject={searchError} />
														</div>
													</div>
												</> : <>
													{/* No data after search */}
													<div className="row">
														<div className="col-sm-12">
															<ErrorMsgBlockComponent noData={true} />
														</div>
													</div>
												</>) : <>
													{/* No filters applied */}
													<div className="card-body">
														<p className="p-4 m-0 text-center no-filter-msg">{caseFilterErrorMessages.noFilterApplied}</p>
														<p className="p-0 m-0 text-center">OR</p>
														<p className="p-4 m-0 text-center">
															<button type="button" className="btn btn-primary text-uppercase" onClick={this.toggleUploadModal}>Upload New</button>
														</p>
													</div>
												</>}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Modal to show upload file modal */}
				<CustomModal
					id="mapped-user-details-modal"
					show={showUploadModal}
					title="Upload Log File"
					isComponent={true}
					hideClose={true}
					dialogClassName="file-upload-dialog"
					closeAction={this.toggleUploadModal}>
					<LogUploadContainer toggleUploadModal={this.toggleUploadModal} />
				</CustomModal>
			</>
		)
	}
}
